import { Component, OnInit, Input } from '@angular/core';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {
  @Input() showLoader: boolean;
  constructor(private _loader: LoaderService) { }

  ngOnInit(): void {
    this._loader.status.subscribe((val: boolean) => {
      this.showLoader = val
    });
  }

}
